import React from 'react';
import SharingSetupModal from '../SharingSetupModal';
import type { SharingSetupProps } from '../types';
import { eventInjectableFields } from './injectableFields';
import defaultShareFormYaml from './default_share_form.yaml?raw';

/** Event share-message form editor: the shared shell seeded with the event form. */
const SharingSetup: React.FC<SharingSetupProps> = props => (
  <SharingSetupModal
    {...props}
    defaultShareFormYaml={defaultShareFormYaml}
    injectableFields={eventInjectableFields}
  />
);

export default SharingSetup;
